import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  customInputWrapper: {
    display: 'flex',
    marginBottom: theme.app.spacing.sm,
    position: 'relative',
    flexDirection: 'column',

    '& .custom-input__label': {
      color: theme.app.colors.text.primary,
      fontSize: theme.app.typography.label.fontSize
    },
    '& .custom-input__input': {
      width: 'calc(100% - 16px)',
      margin: `${theme.app.spacing.sm}px 0`,
      resize: 'none',
      minHeight: 97,
      padding: theme.app.spacing.sm,
      borderRadius: theme.app.borderRadius.sm,
      backgroundColor: theme.app.colors.input.background,
      color: theme.app.colors.text.primary,
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      border: 'none',
      boxSizing: 'content-box',

      '&:focus': {
        outlineWidth: 0,
        border: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      }
    },

    '& .custom-input__error': {
      top: 67,
      left: 0,
      display: 'block',
      width: '100%',
      position: 'absolute',
      color: theme.app.indication.danger,
      fontSize: theme.app.typography.error.fontSize,

      whiteSpace: 'normal',
      wordBreak: 'break-word'
    },

    '@media (min-width:961px)': {
      '& .custom-input__input': {
        display: 'flex'
      }
    }
  }
}))
